import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import Chip from '@material-ui/core/Chip'
import { RootMeta } from 'components/Meta'
import kebabCase from 'lodash/kebabCase'
import goToUrl from 'utils/goToUrl'

const styles = (theme) => ({
  root: {
    minHeight: '90vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tag: {
    background: theme.palette.primary.main,
    color: '#fff',
    cursor: 'pointer',
    margin: theme.spacing.unit / 4,
    '&:hover': {
      background: theme.palette.accent.gray,
    },
  },
})

const TagsPage = ({ classes, data }) => {
  const tags = data.allMarkdownRemark.group
  const {
    site: { siteMetadata },
  } = data

  return (
    <div className={classes.root}>
      <RootMeta
        title={`Tags | ${siteMetadata.siteName}`}
        url={siteMetadata.siteUrl}
        description={siteMetadata.siteDescription}
      />
      <div style={{ textAlign: 'center' }}>
        {tags.map(({ fieldValue, totalCount }, i) => {
          return (
            <Chip
              key={`tag${i}${fieldValue}`}
              onClick={goToUrl(`/tags/${kebabCase(fieldValue)}`)}
              className={classes.tag}
              size="small"
              label={
                <React.Fragment>
                  {fieldValue}{' '}
                  <span style={{ paddingLeft: 10, opacity: 0.6 }}>
                    {totalCount}
                  </span>
                </React.Fragment>
              }
            />
          )
        })}
      </div>
    </div>
  )
}

TagsPage.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
}

// eslint-disable-next-line
export const query = graphql`
  query TagsQuery {
    site {
      siteMetadata {
        siteName
        siteUrl
        siteDescription
      }
    }
    allMarkdownRemark {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`

export default withStyles(styles)(TagsPage)



// WEBPACK FOOTER //
// ./src/pages/tags.js